<ng-content></ng-content>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/sidenav/typings/index.d.ts.MatSidenavContent.html